module.exports = __webpack_public_path__ + "static/media/ic_tick_circle.7b23bf09.svg";